/// <reference types="@types/google.maps" />
import { GeoPoint } from '../models';
import { isNullOrUndefined } from './util';

export class DistanceUtil {
  static convertMetersToMiles(meters: number, toFixed: number = null): number {
    const miles = meters * 0.000621371;
    return isNullOrUndefined(toFixed) ? miles : parseFloat(miles.toFixed(toFixed));
  }

  static computeDistanceBetween(geoPoint1: GeoPoint, geoPoint2: GeoPoint): number {
    return google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(geoPoint1.latitude, geoPoint1.longitude),
      new google.maps.LatLng(geoPoint2.latitude, geoPoint2.longitude)
    );
  }
}
